// Copy text to the clipboard, falling back for webviews without the async
// Clipboard API (older iOS WKWebView, and any context where the permission is
// denied). The fallback has to stay: navigator.clipboard is unavailable in
// enough of the app's install base that dropping it silently breaks copy.
// Returns true only when the text actually reached the clipboard, so callers
// don't confirm a copy that silently failed — execCommand reports failure by
// returning false rather than throwing.
export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    // Fall through to the textarea path below.
  }

  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.select();
  try {
    return document.execCommand('copy');
  } catch {
    return false;
  } finally {
    document.body.removeChild(textarea);
  }
}
